var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.modifierClasses },
    [
      _vm.href
        ? [_c("a", { attrs: { href: _vm.href } }, [_vm._t("default")], 2)]
        : [_vm._t("default")],
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "rb-registration-callout__close-icon common__icon",
          class: _vm.iconClasses,
          on: { click: _vm.close },
        },
        [_vm._v("close")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }